if(!customElements.get('hero-section')) {

  class HeroSection extends HTMLElement {

    constructor() {
      super();
      this.getContext();
      window.addEventListener("resize", () => {
        this.getContext();
      });
      this.handleGoToNextSection();
      this.handleHeartEffect();
    }

    getContext() {
      var isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
          window.innerWidth < 768;
      var isTablet = ( /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ) && window.innerWidth < 1024;
      if (isMobile) {
        this.context = 'phone';
      } else if (isTablet) {
        this.context = 'tablet';
      } else {
        this.context = 'desktop';
      }
    }

    handleHeartEffect() {

      // Target hero elements
      const currentHeroSection = this;
      const compare = currentHeroSection.dataset.scrollId;
      const currentHeroHeart = currentHeroSection.querySelector('.hero__heart .icon');

      // Stop when the heart is not there, breakpoint is below 1024 or lmScroll is not defined.
      if(!currentHeroHeart || this.context != 'desktop' || !lmScroll) {
        return;
      }

      // Track scroll
      lmScroll.on('scroll', (args) => {

        // Get all current elements : args.currentElements, get first hero to animate
        if(typeof args.currentElements[compare] === 'object') {

          // Read the progress
          const current = args.currentElements[compare];
          const sectionHeight = current.top - current.bottom;

          // Check if the scroll is inside the hero element
          if(args.scroll.y >= current.top && args.scroll.y <= current.bottom) {
            const remainingHeight = args.scroll.y - current.bottom;
            const percentage = ( 100 - (remainingHeight / sectionHeight * 100) ) / 100;
            // const opacity = ( 1 - (remainingHeight / sectionHeight) ) * 2;
            const transformValue = `scale3d(${percentage}, ${percentage}, 1)`;
            currentHeroHeart.setAttribute("style", `transform: ${transformValue}; -webkit-transform: ${transformValue};`);
          }

          // Scale back to 0 when it's in the beginning of the section.
          if(args.scroll.y < current.top) {
            const transformValue = `scale3d(0,0,1)`;
            currentHeroHeart.setAttribute("style", `transform: ${transformValue}; -webkit-transform: ${transformValue};`);
          }

        }
      });

    }

    handleGoToNextSection () {
      // Go to next section slide
      const heroGoToNextSectionButtons = this.querySelectorAll('[data-hero-go-to-next-section]');
      heroGoToNextSectionButtons.forEach(button => {
        button.addEventListener('click', function(){
          const currentSection = button.closest('.shopify-section');
          const nextSection = currentSection.nextElementSibling;
          if(nextSection != null) {
            if(lmScroll) {
              lmScroll.scrollTo(nextSection);
            } else {
              nextSection.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
          }
        });
      });
    }

  }

  window.HeroSection = HeroSection;

  customElements.define('hero-section', HeroSection);

}